import React from 'react';
import Sidebar, { EXPANDED_WIDTH, COLLAPSED_WIDTH } from './Sidebar';
import { useSidebar } from '../../context/SidebarContext';
import './layout-responsive.css';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { collapsed } = useSidebar();
  const marginLeft = collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH;

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <main className="app-main" style={{
        flex: 1,
        marginLeft: `${marginLeft}px`,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
      }}>
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
